import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/api";

export const getAppearencesThunk = createAsyncThunk(
    'appearances/getAppearencesThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.appearences(data);
            
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getAllCatThunk = createAsyncThunk(
    'appearances/getAllCatThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.allcategories(data);
            
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


const loadAppearancesFromStorage = () => {
    try {
        const cached = localStorage.getItem("appearences");
        return cached ? JSON.parse(cached) : {};
    } catch (error) {
        console.error("Failed to load appearances from localStorage", error);
        return {};
    }
};

const appearancesSlice = createSlice({
    name: 'appearences',
    initialState:{
       appearences : loadAppearancesFromStorage(),
       loading:false,   
       categories:[]
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAppearencesThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAppearencesThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.appearences = action.payload;
                try {
                    localStorage.setItem("appearences", JSON.stringify(action.payload));
                } catch (error) {
                    console.error("Failed to save appearances to localStorage", error);
                }
            })
            .addCase(getAppearencesThunk.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getAllCatThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllCatThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload
            })
            .addCase(getAllCatThunk.rejected, (state, action) => {
                state.loading = false;
            })
    },
});


export default appearancesSlice.reducer